import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { PassengerDto } from './_models/passenger-dto.model';

@Injectable({
  providedIn: 'root'
})
export class SharedPassengerService {
  constructor(private readonly http: HttpClient) {}

  private readonly baseUrl = '/sdapi/pre-flight/scheduling/passengers';

  searchPassengers(searchString: string): Observable<PassengerDto[]> {
    const url = `${this.baseUrl}/search`;
    const params = new HttpParams().set('searchCriteria', searchString);

    return this.http.get<PassengerDto[]>(url, { params });
  }

  isDuplicatePassengerEmail(emailAddress: string): Observable<boolean> {
    if (!emailAddress || emailAddress.trim().length < 1) {
      return of(false);
    }

    const url = `${this.baseUrl}/DuplicateEmailCheck`;
    const params = new HttpParams().set('emailAddress', emailAddress);

    return this.http.get<boolean>(url, { params });
  }

  isDuplicatePassengerName(firstName: string, lastName: string): Observable<boolean> {
    const url = `${this.baseUrl}/DuplicateNameCheck`;
    const params = new HttpParams().set('firstName', firstName).set('lastName', lastName);

    return this.http.get<boolean>(url, { params });
  }

  savePassenger(passenger: PassengerDto): Observable<PassengerDto> {
    return this.http.post<PassengerDto>(this.baseUrl, passenger);
  }
}
